import _ from "lodash";

export const shouldApplyProfileContact = <Contact>(
    profileValue: Contact,
    lastAppliedValue: Contact,
    formValue: Contact,
    edited: boolean,
    touched: boolean
) =>
    !edited &&
    !touched &&
    !_.isEqual(profileValue, lastAppliedValue) &&
    _.isEqual(formValue, lastAppliedValue);
